import { useCallback } from 'react';

import useToast from 'components/ToastProvider/useToast';

import { CopyTextToClipboardHook } from './types';

const createNonVisibleTextAreaElement = () => {
  const textArea = document.createElement('textarea');
  textArea.style.position = 'fixed';
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.width = '2em';
  textArea.style.height = '2em';
  textArea.style.padding = '0';
  textArea.style.border = 'none';
  textArea.style.outline = 'none';
  textArea.style.boxShadow = 'none';
  textArea.style.background = 'transparent';
  return textArea;
};

const useCopyTextToClipboard: CopyTextToClipboardHook = ({
  copySuccessMessage,
  textToCopy,
}) => {
  const { showToast } = useToast();
  return useCallback(() => {
    if (textToCopy === undefined) {
      throw new Error(
        'textToCopy should be available before calling CopyToClipboardFn',
      );
    }
    // Uses a technique of temporarily adding a text area to the DOM (and removing it in
    // the same frame) to copy the text to the clipboard.
    // See https://stackoverflow.com/a/30810322/12106156
    const textArea = createNonVisibleTextAreaElement();
    textArea.value = textToCopy;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    showToast({
      message: copySuccessMessage,
      type: 'success',
    });
  }, [copySuccessMessage, textToCopy, showToast]);
};

export default useCopyTextToClipboard;
